import React from 'react';
import PropTypes from 'prop-types';
import { Box } from 'rebass';
import PageLayout from '.';
import PrismicSlice from './PrismicSlice';
import { useStaticQuery, graphql } from 'gatsby';
import usePreviewData from '../../../utils/usePreviewData';

const PrismicPage = ({ pageContext }) => {
  const { uid } = pageContext?.data;
  // query all pages again because gatsby won't allow query variables 🤷
  const { allPrismicPage } = useStaticQuery(graphql`
    {
      allPrismicPage(limit: 1000) {
        nodes {
          uid
          data {
            title {
              text
            }
            meta_title
            meta_description
            meta_og_image {
              thumbnails {
                og {
                  url
                }
              }
            }
            content {
              html
            }
            max_width
            body {
              __typename
              ... on PrismicPageBodyContent {
                primary {
                  rich_text_content {
                    html
                  }
                }
              }
              ... on PrismicPageBodyFaculty {
                primary {
                  faculty_section_title {
                    html
                    text
                  }
                }
                items {
                  faculty_member {
                    document {
                      ... on PrismicFacultyMember {
                        data {
                          name
                          position
                          portrait {
                            fluid(maxWidth: 320) {
                              ...GatsbyPrismicImageFluid
                            }
                          }
                          bio {
                            html
                          }
                        }
                      }
                    }
                  }
                }
              }
              ... on PrismicPageBodyFaqSection {
                primary {
                  faq_title_description {
                    html
                  }
                }
                items {
                  faq_question
                  faq_answer {
                    html
                  }
                }
              }
              ... on PrismicPageBodyListOfGraduatesPractitioners {
                id
              }
              ... on PrismicPageBodyImage {
                slice_type
                slice_label
                primary {
                  source {
                    url
                  }
                  alignment
                  caption
                }
              }
              ... on PrismicPageBodyImageGrid {
                slice_type
                slice_label
                items {
                  source {
                    url
                  }
                  caption
                }
              }
            }
          }
        }
      }
    }
  `);
  const thisPage = allPrismicPage.nodes.find(page => page.uid === uid);
  const liveData = usePreviewData({ prismicPage: thisPage })?.prismicPage?.data;
  const title = liveData?.title?.text;
  const { meta_title, meta_description, meta_og_image } = liveData;
  const contentHtml = liveData?.content?.html;
  const slices = liveData?.body;
  const maxWidth = liveData?.max_width || 768;
  return (
    <PageLayout
      title={title}
      meta_title={meta_title}
      meta_description={meta_description}
      meta_og_image={meta_og_image?.og?.url}
      maxWidth={maxWidth}
      content={contentHtml}
    >
      <Box>
        {slices?.map(slice => (
          <Box mb={5} key={slice.id}>
            <PrismicSlice data={slice} />
          </Box>
        ))}
      </Box>
    </PageLayout>
  );
};

PrismicPage.propTypes = {
  data: PropTypes.shape({
    prismicPage: PropTypes.shape({
      data: PropTypes.shape({
        title: PropTypes.string,
        content: PropTypes.shape({
          html: PropTypes.string,
        }),
        body: PropTypes.arrayOf(PropTypes.object),
      }),
    }),
  }),
};

export default PrismicPage;
